class Counters {
    constructor() {
        this.initialize();
    }

    initialize() {
        /**
         * Ссылка на детальную страницу с карточки товара в разделах каталога
         * Также кнопка показа попапа предварительного просмотра
         */
        $(document).on('click', '[data-product-container] [data-card] a', function () {
            if (typeof dataLayer !== 'undefined') {
                let productId = $(this).closest('[data-card]').data('card');

                dataLayer.push({'event' : 'more model', 'product_id' : productId});
            }
        });

        /**
         * Кнопкка "В корзину" на попапе предварительного просмотра в разделах каталога
         */
        $(document).on('click', '#quickview [data-product-buy]', function () {
            if (
                (typeof ga !== 'undefined')
                && ($(this).text() !== 'Перейти в корзину')
            ) {
                ga('send', 'event', 'button', 'add_to_cart');
            }
        });

        /**
         * Кнопка "В корзину" на детальной странице товара
         */
        $(document).on('click', '.product-detail .add-to-cart', function () {
            if (
                (typeof ga !== 'undefined')
                && ($(this).text() !== 'Перейти в корзину')
            ) {
                ga('send', 'event', 'button', 'add_to_cart');
            }
        });
    }

    /**
     * Обработка добавления/удаления товаров в корзину
     *
     * @param actions
     * @constructor
     */
    GA_BasketActions(actions) {
        window.dataLayer = window.dataLayer || [];
        for (var action in actions) {
            var textAction = '';
            if(action == 'add') {
                textAction = 'Adding a Product to a Shopping Cart';
                (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
                    try {
                        rrApi.addToBasket([actions[action][0]['sku_id']]);
                    } catch (e) {
                        console.log(e)
                    }
                })
				dataLayer.push({
					event: 'addToCart',
					ecommerce: {
						add: {
							actionField: {list: actions[action][0]['list']},
							products: [{
								name: actions[action][0]['name'],
								id: actions[action][0]['id'],
								price: actions[action][0]['price'],
								brand: actions[action][0]['brand'],
								category: actions[action][0]['category'],
								variant: actions[action][0]['variant'],
								quantity: actions[action][0]['quantity']
							}]
						}
					}
				});

            }
            if(action == 'remove') {
                textAction = 'Removing a Product from a Shopping Cart';
            }

            if (typeof ga !== 'undefined') {
                ga('ec:addProduct', actions[action]);
                ga('ec:setAction', action);
                ga('send', 'event', 'UX', 'click', textAction);
            }

            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'RUB',
                    [action]: {
                        'products': actions[action],
                    },
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': textAction,
                'gtm-ee-event-non-interaction': 'False',
            });
        }
    }

    GA_ViewItem(offer_id, price) {
        $.post(
            '/local/ajax/ga.php',
            {
                action: 'view_item',
                offer_id: offer_id,
                price: price
            }
        ).done(function(response) {
            if (
                (response.status === 'ok')
                && response.dataLayer
            ) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push(response.dataLayer);
            }

            if (response.status === 'error') {
                console.error(response.message);
            }
        })
    }
}

window.Counters = new Counters();
